import { render, staticRenderFns } from "./MembersCard.vue?vue&type=template&id=9becf10a&scoped=true&"
import script from "./MembersCard.vue?vue&type=script&lang=js&"
export * from "./MembersCard.vue?vue&type=script&lang=js&"
import style0 from "./MembersCard.vue?vue&type=style&index=0&id=9becf10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9becf10a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
